import React from 'react'
import { ErrorModal } from './../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY, authRedirect } from '../../../dataHelpers/authenticationHelpers'
import { Table } from 'reactstrap'
import '../../../stylesheets/Provision.css'
import { Nav, NavItem, NavLink } from 'reactstrap'
import EditPlanIcon from 'react-icons/lib/fa/edit'
import AddPlanIcon from 'react-icons/lib/fa/plus-square'
import ExtendIcon from 'react-icons/lib/fa/expand'
import SubsListIcon from 'react-icons/lib/fa/list'
import classnames from 'classnames'
import tapOrClick from 'react-tap-or-click'
import Loader from 'react-loader-spinner'

class SubscriptionPlanList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            activeTab: '4',
            allPlanData: []
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.fetchAllSubsPlanList = this.fetchAllSubsPlanList.bind(this)
    }

    async componentDidMount() {
        if (this.token) {
            this.fetchAllSubsPlanList()
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async fetchAllSubsPlanList() {
        let allplanlistResponse = await subscriptionHelpers.getAllPlanList(this.token)
        if (!allplanlistResponse.error) {
            this.setState({ allPlanData: allplanlistResponse })
        } else {
            this.setState({ errors: [allplanlistResponse.error] })
        }
    }

    render() {
        let { errors, loading, allPlanData } = this.state
        return (<div>
            <div className="p-0 m-0">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting`, this.props.history)) })}
                        >
                            <AddPlanIcon />&ensp;Create Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptioninitialplan`, this.props.history)) })}
                        >
                            <EditPlanIcon />&ensp;Edit Plan
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '3' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionsetting/extendsubscription`, this.props.history)) })}
                        >
                            <ExtendIcon />&ensp;Extend Plan
                            </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '4' })}
                            {...tapOrClick(() => { (authRedirect(`/management/controllers/subscriptionplanlist`, this.props.history)) })}>
                            <SubsListIcon />&ensp;Available Plans
                            </NavLink>
                    </NavItem>
                </Nav>
            </div>

            <div className="row justify-content-center align-items-center bg-light large-rounded border-light-sf-orange p-0 pb-4">
                <h1 className="text-center mb-4 form-head col-12">Available Subscription Plans</h1>
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <div className="subscription-plan-list">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Subscription Plan</th>
                                    <th>Plan Type</th>
                                    <th>Subscription Days</th>
                                    <th>Subscription Price</th>
                                    <th>Subscription Year</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allPlanData ? allPlanData.map((plandata) => (
                                    <tr>
                                        <td>
                                            <p>{plandata.name}</p>
                                        </td>
                                        <td>{plandata.is_seasoned ? 'Paid' : 'Free'}</td>
                                        <td>{plandata.subscription_days}</td>
                                        <td>
                                            {
                                                plandata.SubscriptionPlanPrice_set.length > 0 ?
                                                    (plandata.SubscriptionPlanPrice_set).map((planPrice) =>
                                                        <tr><td style={{ borderTop: 'none' }}>{'$ ' + planPrice.subscription_price}</td></tr>
                                                    ) : <tr><td style={{ borderTop: 'none' }}>$ 0</td></tr>
                                            }
                                        </td>
                                        <td>
                                            {
                                                plandata.SubscriptionPlanPrice_set.length > 0 ?
                                                    (plandata.SubscriptionPlanPrice_set).map((planYear) =>
                                                        <tr><td style={{ borderTop: 'none' }}>{planYear.subscription_year}</td></tr>
                                                    ) : <tr><td style={{ borderTop: 'none' }}>NA</td></tr>
                                            }
                                        </td>
                                    </tr>
                                )) :
                                    ''}
                            </tbody>
                        </Table>
                    </div>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default SubscriptionPlanList



// WEBPACK FOOTER //
// ./src/components/pages/subscription/SubscriptionPlanList.js